/* oxlint-disable prefer-const */
// We have a pattern to use `let` in these files. Don't mess with it.

import { UserManager, type UserManagerSettings } from "oidc-client-ts";

let logisticsApiUrl =
  import.meta.env.DEV && import.meta.env.VITE_LOCAL_LOGISTICS_BACKEND
    ? () => `https://localhost:7240`
    : (organization: string) =>
        `https://logistics-${organization}-dev.medoma.com`;
let logisticsSseUrl =
  import.meta.env.DEV && import.meta.env.VITE_LOCAL_LOGISTICS_BACKEND
    ? () => `https://localhost:7240`
    : (organization: string) =>
        `https://logisticsbg-${organization}-dev.medoma.com`;
let mapboxApiUrl = "https://api.mapbox.com";
let mapboxPublicAccessToken =
  "pk.eyJ1IjoibWVkb21hIiwiYSI6ImNsN2Z6c2J0bTAwOHozd25xM3JlNzZ6bjUifQ.v2XsEAYwGo00Vk0XZteAZQ";
let patientApiUrl =
  import.meta.env.DEV && import.meta.env.VITE_LOCAL_PATIENTS_BACKEND
    ? () => `https://localhost:7023`
    : (organization: string) => `https://pas-${organization}-dev.medoma.com`;
let authApiUrl =
  import.meta.env.DEV && import.meta.env.VITE_LOCAL_AUTH_BACKEND
    ? `https://localhost:5001`
    : `https://auth-dev.medoma.com`;
let notificationApiUrl =
  import.meta.env.DEV && import.meta.env.VITE_LOCAL_NOTIFICATION_BACKEND
    ? () => `https://localhost:7240/notification`
    : (organization: string) =>
        `https://logistics-${organization}-dev.medoma.com/notification`;
let pushyAppId = "675ad8c47a327a8229eef939";
let intercomAppId = "cqn68r2g";

const hostname = window?.location?.hostname;

const environment =
  hostname === "go.medoma.com"
    ? "prod"
    : hostname === "go.test.medoma.com"
      ? "test"
      : import.meta.env.DEV
        ? "local"
        : "dev";

// Inspired by https://daveceddia.com/multiple-environments-with-react/
if (environment === "prod") {
  logisticsApiUrl = (organization: string) =>
    `https://logistics-${organization}.medoma.com`;
  logisticsSseUrl = (organization: string) =>
    `https://logisticsbg-${organization}.medoma.com`;
  patientApiUrl = (organization: string) =>
    `https://pas-${organization}.medoma.com`;
  authApiUrl = `https://auth.medoma.com`;
  notificationApiUrl = (organization: string) =>
    `https://logistics-${organization}.medoma.com/notification`;
  pushyAppId = "675ada15377b179337a40445";
} else if (environment === "test") {
  logisticsApiUrl = (organization: string) =>
    `https://logistics-${organization}-test.medoma.com`;
  logisticsSseUrl = (organization: string) =>
    `https://logisticsbg-${organization}-test.medoma.com`;
  patientApiUrl = (organization: string) =>
    `https://pas-${organization}-test.medoma.com`;
  authApiUrl = `https://auth-test.medoma.com`;
  notificationApiUrl = (organization: string) =>
    `https://logistics-${organization}-test.medoma.com/notification`;
  pushyAppId = "675aac7c377b179337a4043f";
}

const oidcConfig: UserManagerSettings = {
  authority: authApiUrl,
  client_id: "medoma-go",
  redirect_uri: `${window.location.origin}/login`,
  accessTokenExpiringNotificationTimeInSeconds:
    environment === "prod"
      ? // 3600s access token lifetime in prod, 3600 - 3300 = 300s of no refresh, 3300s refresh window
        3300
      : environment === "test"
        ? // 3600s access token lifetime in test, 3600 - 3300 = 300s of no refresh, 3300s refresh window
          3300
        : // 120s token lifetime in dev, 120 - 90 = 30s of no refresh, 90s refresh window
          90,

  scope:
    "patient.api logistic.api user_type mfa create.otp revoke_session IdentityServerApi set_temporary_pin employee_profile issued_for_app openid organization",
};
export const userManager = new UserManager(oidcConfig);

export const {
  getLogisticsApiUrl,
  getLogisticsSseUrl,
  getPatientApiUrl,
  getNotificationApiUrl,
  MAPBOX_API_URL,
  MAPBOX_PUBLIC_ACCESS_TOKEN,
  AUTH_API_URL,
  PUSHY_APP_ID,
  INTERCOM_APP_ID,
  ENVIRONMENT,
  CHAT_ENVIRONMENT,
} = {
  getLogisticsApiUrl: (organization: string) => logisticsApiUrl(organization),
  getLogisticsSseUrl: (organization: string) => logisticsSseUrl(organization),
  getPatientApiUrl: (organization: string) => patientApiUrl(organization),
  getNotificationApiUrl: (organization: string) =>
    notificationApiUrl(organization),
  MAPBOX_API_URL: mapboxApiUrl,
  MAPBOX_PUBLIC_ACCESS_TOKEN: mapboxPublicAccessToken,
  AUTH_API_URL: authApiUrl,
  PUSHY_APP_ID: pushyAppId,
  INTERCOM_APP_ID: intercomAppId,
  ENVIRONMENT: environment,
  CHAT_ENVIRONMENT: environment === "local" ? "dev" : environment,
};
